import * as React from "react"

const EffectLoading = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    style={{
      margin: "auto",
      background: "#08aae1",
      zIndex: 1,
      position: "relative",
    }}
    preserveAspectRatio="xMidYMid"
  >
    <defs>
      <pattern
        id="a"
        x={0}
        y={0}
        width="100%"
        height="100%"
        patternUnits="userSpaceOnUse"
      >
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 169.885 155.54)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 -86.115 155.54)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 177.368 -2.069)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 177.368 253.931)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 -78.632 -2.069)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 -78.632 253.931)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 34.205 9.559)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 34.205 265.559)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 -221.795 9.559)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 -221.795 265.559)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.1c0-7.9-5.6-14.5-13.1-15.9.1-.8.1-1.5.1-2.2 0-12.3-10-22.3-22.3-22.3-9.5 0-17.7 6-20.8 14.4-1.2-.3-2.4-.5-3.7-.5-7.6 0-13.8 5.9-14.3 13.3-.9-.2-1.9-.3-2.8-.3-7.2 0-13 5.8-13 13 0 4.8 2.6 9 6.5 11.2v.2c0 4.7 3.8 8.5 8.5 8.5 2.7 0 5.1-1.3 6.7-3.2H37.5c2.4 2 5.4 3.2 8.7 3.2s6.4-1.2 8.7-3.2h.2c3.3 3.8 8.2 6.2 13.6 6.2 5.6 0 10.7-2.6 14-6.6C89.6 76.2 95 69.8 95 62.1z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 125.253 75.81)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.1c0-7.9-5.6-14.5-13.1-15.9.1-.8.1-1.5.1-2.2 0-12.3-10-22.3-22.3-22.3-9.5 0-17.7 6-20.8 14.4-1.2-.3-2.4-.5-3.7-.5-7.6 0-13.8 5.9-14.3 13.3-.9-.2-1.9-.3-2.8-.3-7.2 0-13 5.8-13 13 0 4.8 2.6 9 6.5 11.2v.2c0 4.7 3.8 8.5 8.5 8.5 2.7 0 5.1-1.3 6.7-3.2H37.5c2.4 2 5.4 3.2 8.7 3.2s6.4-1.2 8.7-3.2h.2c3.3 3.8 8.2 6.2 13.6 6.2 5.6 0 10.7-2.6 14-6.6C89.6 76.2 95 69.8 95 62.1z"
            fill="#55bedb"
            transform="matrix(.40667 0 0 .40667 -130.747 75.81)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 271.594 16.198)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 271.594 272.198)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 15.594 16.198)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 15.594 272.198)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 -240.406 16.198)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 -240.406 272.198)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 264.485 25.686)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 264.485 281.686)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 8.485 25.686)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 8.485 281.686)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 -247.515 25.686)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 -247.515 281.686)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 27.554 195.637)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 -228.446 195.637)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.1c0-7.9-5.6-14.5-13.1-15.9.1-.8.1-1.5.1-2.2 0-12.3-10-22.3-22.3-22.3-9.5 0-17.7 6-20.8 14.4-1.2-.3-2.4-.5-3.7-.5-7.6 0-13.8 5.9-14.3 13.3-.9-.2-1.9-.3-2.8-.3-7.2 0-13 5.8-13 13 0 4.8 2.6 9 6.5 11.2v.2c0 4.7 3.8 8.5 8.5 8.5 2.7 0 5.1-1.3 6.7-3.2H37.5c2.4 2 5.4 3.2 8.7 3.2s6.4-1.2 8.7-3.2h.2c3.3 3.8 8.2 6.2 13.6 6.2 5.6 0 10.7-2.6 14-6.6C89.6 76.2 95 69.8 95 62.1z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 176.524 40.192)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.1c0-7.9-5.6-14.5-13.1-15.9.1-.8.1-1.5.1-2.2 0-12.3-10-22.3-22.3-22.3-9.5 0-17.7 6-20.8 14.4-1.2-.3-2.4-.5-3.7-.5-7.6 0-13.8 5.9-14.3 13.3-.9-.2-1.9-.3-2.8-.3-7.2 0-13 5.8-13 13 0 4.8 2.6 9 6.5 11.2v.2c0 4.7 3.8 8.5 8.5 8.5 2.7 0 5.1-1.3 6.7-3.2H37.5c2.4 2 5.4 3.2 8.7 3.2s6.4-1.2 8.7-3.2h.2c3.3 3.8 8.2 6.2 13.6 6.2 5.6 0 10.7-2.6 14-6.6C89.6 76.2 95 69.8 95 62.1z"
            fill="#90ddf0"
            transform="matrix(.50833 0 0 .50833 -79.476 40.192)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="2.5s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -298.514 12.414)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -298.514 268.414)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 213.486 12.414)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 213.486 268.414)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -42.514 12.414)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -42.514 268.414)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 24.34 -4.068)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 24.34 251.932)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -231.66 -4.068)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -231.66 251.932)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 31.304 111.96)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -224.696 111.96)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.1c0-7.9-5.6-14.5-13.1-15.9.1-.8.1-1.5.1-2.2 0-12.3-10-22.3-22.3-22.3-9.5 0-17.7 6-20.8 14.4-1.2-.3-2.4-.5-3.7-.5-7.6 0-13.8 5.9-14.3 13.3-.9-.2-1.9-.3-2.8-.3-7.2 0-13 5.8-13 13 0 4.8 2.6 9 6.5 11.2v.2c0 4.7 3.8 8.5 8.5 8.5 2.7 0 5.1-1.3 6.7-3.2H37.5c2.4 2 5.4 3.2 8.7 3.2s6.4-1.2 8.7-3.2h.2c3.3 3.8 8.2 6.2 13.6 6.2 5.6 0 10.7-2.6 14-6.6C89.6 76.2 95 69.8 95 62.1z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 187.938 176.978)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.1c0-7.9-5.6-14.5-13.1-15.9.1-.8.1-1.5.1-2.2 0-12.3-10-22.3-22.3-22.3-9.5 0-17.7 6-20.8 14.4-1.2-.3-2.4-.5-3.7-.5-7.6 0-13.8 5.9-14.3 13.3-.9-.2-1.9-.3-2.8-.3-7.2 0-13 5.8-13 13 0 4.8 2.6 9 6.5 11.2v.2c0 4.7 3.8 8.5 8.5 8.5 2.7 0 5.1-1.3 6.7-3.2H37.5c2.4 2 5.4 3.2 8.7 3.2s6.4-1.2 8.7-3.2h.2c3.3 3.8 8.2 6.2 13.6 6.2 5.6 0 10.7-2.6 14-6.6C89.6 76.2 95 69.8 95 62.1z"
            fill="#afecf6"
            transform="matrix(.61 0 0 .61 -68.062 176.978)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.6666666666666665s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 14.277 57.575)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M94.6 56.2c-1-4.2-3.7-7.6-7.2-9.5 1.6-1.7 2.7-4.1 2.7-6.7 0-5.4-4.4-9.7-9.7-9.7-3.2 0-6.1 1.6-7.8 4-2.5-4.5-7.3-7.6-12.8-7.6-3.4 0-6.4 1.1-8.9 3.1-2.4-4.7-7.3-7.9-13-7.9-5.6 0-10.5 3.2-12.9 7.8-1.3-.3-2.7-.6-4.1-.6-8.8 0-15.9 7-15.9 15.8 0 6 3.4 11.3 8.3 13.9-.2 1.3-.2 2.6.1 3.9 1.2 5.3 6.5 8.6 11.8 7.4.3-.1.6-.1.8-.2 2.9 6 9.6 9.5 16.4 8 5.5-1.3 9.6-5.5 10.9-10.6 2.8 1.3 6.1 1.7 9.4 1 1.8-.4 3.4-1.1 4.8-2.1 3 5.7 9.6 9 16.2 7.5 7.8-1.8 12.7-9.7 10.9-17.5z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 -241.723 57.575)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 -304.076 53.72)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 207.924 53.72)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M85.3 55.6c.3-1.1.5-2.2.6-3.4.5-8.5-6-15.7-14.5-16.2-2.1-.1-4.2.2-6 .9-1.5-8.9-9-16-18.4-16.5-10.9-.7-20.2 7.6-20.8 18.5-.1 1.1 0 2.3.1 3.3-6.3.1-11.6 5-11.9 11.4 0 .8 0 1.5.1 2.2-.3 0-.5-.1-.8-.1-4.5-.1-8.4 3.3-8.7 7.9s3.2 8.4 7.8 8.7c.8 0 1.5 0 2.2-.2 2.5 2.9 8 5.1 14.6 5.5 3.7.2 7.2-.2 10-1.1 1.7 1.8 4.3 3.1 7.3 3.2 4 .2 7.5-1.6 9.3-4.3 2.1 1 4.6 1.7 7.4 1.9 4.5.3 8.6-1 11.1-3 2 1.7 4.6 2.8 7.6 3C89 77.6 94.6 73 95 67c.3-5.5-3.9-10.3-9.7-11.4z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 -48.076 53.72)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 142.586 205.26)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 142.586 -50.74)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 -113.414 205.26)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
        <g>
          <path
            d="M95 62.4c-.5-5.9-5.7-10.3-11.9-10.5v-1.8C82.4 42.5 75.2 37 67 37.7c-.9.1-1.9.3-2.7.5V38c-1-10.9-10.7-19-21.6-18-9.8.9-17.3 8.8-18 18.3C12.8 39.5 4.1 49.2 5.1 60c1 11 11.4 19 23.3 17.9 3.4-.3 6.4-1.3 9.2-2.8 5 3.7 12.4 5.7 20.5 4.9 6.9-.6 13.1-3.2 17.3-6.8 2.3 1.4 5.2 2.2 8.2 1.9 6.8-.7 11.9-6.3 11.4-12.7z"
            fill="#fff"
            transform="matrix(.71167 0 0 .71167 -113.414 -50.74)"
          />
          <animateTransform
            attributeName="transform"
            type="translate"
            keyTimes="0;1"
            repeatCount="indefinite"
            dur="1.25s"
            values="0;256"
          />
        </g>
      </pattern>
    </defs>
    <path fill="url(#a)" d="M0 0h1084v322H0z" />
  </svg>
)

export default EffectLoading